import dayjs from 'dayjs/esm/index.js'
import utc from 'dayjs/esm/plugin/utc'
import timezone from 'dayjs/esm/plugin/timezone'
import isBetween from 'dayjs/esm/plugin/isBetween'
import isSameOrBefore from 'dayjs/esm/plugin/isSameOrBefore'
import isSameOrAfter from 'dayjs/esm/plugin/isSameOrAfter'

import locale_en from 'dayjs/locale/en'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)
dayjs.extend(isSameOrBefore)
dayjs.extend(isSameOrAfter)

export const baseDayJs = (date: string, locale: any, timezone = 'europe/amsterdam') => {
  return dayjs.utc(date).tz(timezone).locale(locale || locale_en)
}
